import { render, staticRenderFns } from "./admissionsAdmin.vue?vue&type=template&id=552e0743&scoped=true"
import script from "./admissionsAdmin.vue?vue&type=script&lang=js"
export * from "./admissionsAdmin.vue?vue&type=script&lang=js"
import style0 from "./admissionsAdmin.vue?vue&type=style&index=0&id=552e0743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e0743",
  null
  
)

export default component.exports